import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Category } from 'src/app/interfaces/api/category';
import { encodeQueryParam } from 'src/helpers';

@Component({
  selector: 'app-category-card',
  templateUrl: './category-card.component.html',
  styleUrls: ['./category-card.component.scss'],
})
export class CategoryCardComponent implements OnInit {
  @Input() size: 'small' | 'large' = 'large';
  @Input() category: Category;

  constructor(private router: Router, private navController: NavController) {}

  ngOnInit() {}

  async navigateCategoryDetail(categoryId: number, hasChild: boolean) {
    if (hasChild) {
      this.router.navigateByUrl(`/category-detail/${categoryId}`);
      return;
    }

    this.router.navigate([`/subcategory-detail/${categoryId}`], {
      queryParams: { category_name: encodeQueryParam(this.category.name), tags: encodeQueryParam(this.category.tags) },
    });
  }

  capitalizeEachWord(str: string) {
    if (!str || typeof str !== 'string') {
      return '';
    }

    const words = str.toLowerCase().split(' ');
    const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
    return capitalizedWords.join(' ');
  }
}
